<template>
  <MyForm :title="'New Customer'">
    <template v-slot:fields>
      <!--Form-input v-model="customer.id" :readonly=true :disabled=true :name="'customer id:'"></Form-input>
            <Form-input v-model="customer.created_by" :readonly=true :disabled=true :name="'created by:'"></Form-input>
            <Form-input v-model="customer.created_on" :readonly=true :disabled=true :name="'created on:'"></Form-input>
            <Form-input v-model="customer.modified_on" :readonly=true :disabled=true
                :name="'modified on:'"></Form-input>
        -->
      <Form-input v-model="customer.name" :name="'name:'"></Form-input>
      <Form-input v-model="customer.companyName" :name="'company name:'"></Form-input>
      <Form-input v-model="customer.invoiceName" :name="'invoice name:'"></Form-input>
      <Form-email v-model="customer.email" :name="'email:'"></Form-email>
      <FormTextArea v-model="customer.notes" :name="'notes:'"></FormTextArea>
      <Form-input
        v-model="customer.source"
        :name="'source:'"
        :placeholder="'word of mouth, website, kijiji, etc.'"
      ></Form-input>
    </template>

    <template v-slot:buttons>
      <div class="btn-footer">
        <FormBtn :name="'Add New Customer'" @clicked="submitForm"></FormBtn>
        <FormBtn :name="'Cancel'" @clicked="cancelForm"></FormBtn>
      </div>
    </template>
  </MyForm>

  <!--div class="debug">
        <p> customer = {{ customer }}</p>
       
        
    </div>-->
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import type { Customer } from '@/types/types'
import { useCustomerStore, useAlertStore } from '@/stores'
import router from '@/router'

//import FormInput from '@/components/form/Form-input.vue';
import { MyForm, FormBtn, FormInput, FormEmail, FormTextArea, EmailGroup } from '@/components'

const customers = useCustomerStore()
//const props = defineProps({ id: { type: Number, required: true } });
const newCustomer = {
  name: '',
  companyName: '',
  invoiceName: '',
  email: '',
  notes: ''
}
const customer = ref<Customer>(newCustomer)

watch(
  () => customer.value.name,
  (newVal, oldVal) => {
    customer.value.invoiceName =
      newVal + (customer.value.companyName != '' ? ' - ' + customer.value.companyName : '')
  },
  { deep: true }
)

watch(
  () => customer.value.companyName,
  (newVal, oldVal) => {
    customer.value.invoiceName =
      (customer.value.name != '' ? customer.value.name + ' - ' : '') + newVal
  },
  { deep: true }
)

//add new customer, check if existing
async function submitForm() {
  console.log('Customer create.submitForm()...')
  customers.add(customer.value)
}

async function cancelForm() {
  console.log('CustomerDetailsView.revertForm()...')
  router.back()
  //await fetchCustomer();
  //customer.value = await customers.getById(customerId);
}
</script>

<style lang="css" scoped>
.btn-footer {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
}

.emails-div {
  display: flex;
  flex-direction: row;
  gap: 5rem;
}
</style>
